import { createContext, useContext, useState, useCallback } from "react";

const TrendCtx = createContext(null);

/**
 * TrendProvider — global provider that lets ANY widget open the
 * full-screen "Trend Analyzer" dialog without prop drilling.
 *
 * Usage:
 *   const { openTrend } = useTrend();
 *   openTrend({ widgetId, label, module, unit, current });
 */
export function TrendProvider({ children }) {
  const [ctx, setCtx] = useState(null); // { open, widgetId, label, module, unit, current }

  const openTrend = useCallback((payload) => {
    if (!payload || !payload.widgetId) return;
    setCtx({ open: true, ...payload });
  }, []);

  const closeTrend = useCallback(() => {
    setCtx((c) => (c ? { ...c, open: false } : c));
  }, []);

  return (
    <TrendCtx.Provider value={{ openTrend, closeTrend, ctx }}>
      {children}
    </TrendCtx.Provider>
  );
}

export const useTrend = () => {
  const v = useContext(TrendCtx);
  if (!v) throw new Error("useTrend must be used within TrendProvider");
  return v;
};
